import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as FlatModels from '@medsurf/flat-models';
import { AppSharedFacade, AuthControlFacade, NavigationControlFacade, NodeSharedFacade } from '@medsurf/flat-facades';
import {
  AuthControlService,
  FLAT_SETTINGS,
  MediaControlService,
  ModalControlService,
  NavigationControlService,
  SettingControlModel
} from '@medsurf/flat-services';
import { UserEntityModels } from '@medsurf/flat-models';
import { combineLatest, filter, map } from 'rxjs';

@Component({
    selector: 'medsurf-navbar',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent {
  /**
   * Constructor
   *
   * @param appSharedFacade
   * @param nodeSharedFacade
   * @param navigationControlFacade
   * @param authControlFacade
   * @param modalControlService
   * @param translate
   * @param router
   * @param mediaControlService
   * @param navigationControlService
   * @param settings
   */
  public constructor(public appSharedFacade: AppSharedFacade,
                     public nodeSharedFacade: NodeSharedFacade,
                     public navigationControlFacade: NavigationControlFacade,
                     public authControlFacade: AuthControlFacade,
                     public authControlService: AuthControlService,
                     public modalControlService: ModalControlService,
                     public translate: TranslateService,
                     public router: Router,
                     public mediaControlService: MediaControlService,
                     public navigationControlService: NavigationControlService,
                     @Inject(FLAT_SETTINGS) public settings: SettingControlModel) {
  }

  public showHome$ = combineLatest([
    this.router.events.pipe(filter<NavigationEnd>(e => e instanceof NavigationEnd)),
    this.nodeSharedFacade.currentSelectedSettings$
  ]).pipe(map(([event, settings]) => {
    return event.url !== '/' && !settings?.hideHomeButton;
  }))

  public localTitleClicked() {
    this.navigationControlService.goSubject();
  }

  public localClose() {
    window.close();
  }

  public logout() {
    this.authControlService.oidcAuthLogout();
  }

  public openModal() {
    this.modalControlService.openModal();
  }

  public downloadPDF(pdfMedia: FlatModels.MediaEntityModels.MediaEntityType): void {  
    if (pdfMedia) {
      const pdfUrl = this.mediaControlService.getPDFDownloadUrl(pdfMedia, 'viewer');
      window.open(pdfUrl, '_blank');
    }
  }

  public editInAuthor(currentUrl: string) {
    const url = `${this.settings.authorUrl}${currentUrl}`;
    open(url, '_medsurf_author');
  }

  trackByPageId(index: number, item: any): number {
    return item.pageId;
  }
}
